import React, { Fragment, ReactNode } from "react";
import More from "../components/Footer/More";

export default function replaceTechPlusMore(
  subject: string,
  className = "w-10 align-bottom text-brand"
): ReactNode {
  return subject.split(/(Tech\+More)/).map((s, i) =>
    s === "Tech+More" ? (
      <Fragment key={i}>
        Tech+
        <More className={className} />
      </Fragment>
    ) : (
      s
    )
  );
}
